import { render } from "./SectionHeader.vue?vue&type=template&id=b3c95b4a&scoped=true"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

import "./SectionHeader.vue?vue&type=style&index=0&id=b3c95b4a&scoped=true&lang=css"
import "./SectionHeader.vue?vue&type=style&index=1&id=b3c95b4a&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c95b4a"]])

export default __exports__